export const HOME_HEALTH_VISIT_VERIFICATION_MOBILE_PATH = "/home-health/visit-verification/mobile";
